module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgOC4zMDhBNSA1IDAgMCAwIDUuNTQgMCA2IDYgMCAxIDEgMCA4LjMwOHoiIGZpbGw9IiNBNUIxQ0IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbC1vcGFjaXR5PSIuNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/evening.svg
// module id = 189
// module chunks = 0